import { withInstall } from '@vuemap/vue-amap-util'
import BezierCurve from './BezierCurve.vue'

export const ElAmapBezierCurve = withInstall(BezierCurve)
export default ElAmapBezierCurve
